import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'provider.lastBranchId';

const BranchNavContext = createContext({
  branchId: 'store',
  branchHomePath: '/branch/store',
  productsPath: '/branch/store/products',
});

function parseBranchIdFromPath(pathname) {
  const match = String(pathname || '').match(/^\/branch\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function readStoredBranchId() {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch (_) {
    return null;
  }
}

function writeStoredBranchId(branchId) {
  try {
    sessionStorage.setItem(STORAGE_KEY, branchId);
  } catch (_) {
    // ignore
  }
}

export function BranchNavProvider({ children }) {
  const { pathname } = useLocation();
  const [branchId, setBranchId] = useState(
    () => parseBranchIdFromPath(pathname) || readStoredBranchId() || 'store'
  );

  useEffect(() => {
    const fromPath = parseBranchIdFromPath(pathname);
    if (!fromPath) return;
    setBranchId(fromPath);
    writeStoredBranchId(fromPath);
  }, [pathname]);

  const value = useMemo(
    () => ({
      branchId,
      branchHomePath: `/branch/${branchId}`,
      productsPath: `/branch/${branchId}/products`,
    }),
    [branchId]
  );

  return (
    <BranchNavContext.Provider value={value}>{children}</BranchNavContext.Provider>
  );
}

export function useBranchNav() {
  return useContext(BranchNavContext);
}
